import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "43",
  height: "39",
  viewBox: "0 0 43 39",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M36.9583 37.1663H6.04167C3.60241 37.1663 1.625 35.1889 1.625 32.7497L1.625 6.24967C1.625 3.81041 3.60241 1.83301 6.04167 1.83301L28.125 1.83301C30.5643 1.83301 32.5417 3.81042 32.5417 6.24968V8.45801M36.9583 37.1663C34.5191 37.1663 32.5417 35.1889 32.5417 32.7497L32.5417 8.45801M36.9583 37.1663C39.3976 37.1663 41.375 35.1889 41.375 32.7497V12.8747C41.375 10.4354 39.3976 8.45801 36.9583 8.45801L32.5417 8.45801M23.7083 1.83301L14.875 1.83301M10.4583 28.333H23.7083M10.4583 10.6663H23.7083V19.4997H10.4583V10.6663Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }